import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '../../services/localization.service';
import { englishDaysShort } from '../../constants/english-days';

@Pipe({
  name: 'shortDayOfWeek',
})
export class ShortDayOfWeekPipe implements PipeTransform {
  transform(value: any, useNumberOfDay: boolean = false): any {
    if(useNumberOfDay) {
      return englishDaysShort[value];
    }

    let date = new Date(value);
    return date.toLocaleString(LocalizationService.getCurrentCultureCode(), { weekday: 'short' });
  }
}
